import { render, staticRenderFns } from "./end-game-view.vue?vue&type=template&id=32618415"
import script from "./end-game-view.vue?vue&type=script&lang=js"
export * from "./end-game-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports